// hooks/useCurrentStore.ts
import { useState, useEffect } from "react";

const getUser = () => JSON.parse(localStorage.getItem("user") || "{}");

export const getInitialStoreId = (fallback?: string) =>
fallback || localStorage.getItem("currentStoreId") || getUser()?.stores?.[0]?.id;
/*
  localStorage.getItem("currentStoreId")
  || fallback
  || getUser()?.stores?.[0]?.id;
*/
export function useCurrentStore(fallbackId?: string) {
  const [storeId, setStoreId] = useState<string>(
    () => getInitialStoreId(fallbackId)
  );

  useEffect(() => {
    if(fallbackId) return;
    const handler = () => {
      const newId = localStorage.getItem("currentStoreId");
      if (newId) setStoreId(newId);
    };
    window.addEventListener("store-changed", handler);
    window.addEventListener("user-updated", handler);
    return () => {
      window.removeEventListener("store-changed", handler);
      window.removeEventListener("user-updated", handler);
    };
  }, [fallbackId]);

  return storeId;
}